import { render, staticRenderFns } from "./ListEmpty.vue?vue&type=template&id=2498e0ad&"
import script from "./ListEmpty.vue?vue&type=script&lang=js&"
export * from "./ListEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports